import React from "react";
import { MemberInfoCard, MemoControllerBox, OverflowMenu } from "@icoach/components";
import { StatusChipTooltip } from "@icoach/rentCabinet/CabinetOverviewTable";
import { COLOR_MATCH } from "@icoach/accountBook/staticData";
import { formatCurrencyFn } from "@util/utils";
import { buildOrderMenuData } from "@icoach/accountBook/utils/buildOrderMenuData";

export const getDebitCashRowsLabel = () => [
	{
		cellKey: "displayName",
		headerLabel: "會員",
		align: "left",
		maxWidth: 20.4,
		formatCell: (displayName, { maskDisplayName, memberNo, memberPicturePath }, { isRevealed }) => {
			return <MemberInfoCard name={isRevealed ? displayName : maskDisplayName} memberNo={memberNo} avatar={memberPicturePath} />;
		},
	},
	{
		cellKey: "statusText",
		headerLabel: "狀態",
		align: "center",
		formatCell: (cellValue, { status, statusColor = 0, processResult }) => {
			return <StatusChipTooltip statusText={cellValue} statusMemo={processResult} color={COLOR_MATCH[statusColor]} isShowTip={String(status) === "9"} />;
		},
	},
	{
		cellKey: "itemName",
		headerLabel: "品項",
		align: "center",
	},
	{
		cellKey: "totalPrice",
		headerLabel: "扣款金額",
		align: "center",
		formatCell: cellValue => {
			return formatCurrencyFn(cellValue);
		},
	},
	{
		cellKey: "returnPrice",
		headerLabel: "退款金額",
		align: "center",
		formatCell: cellValue => {
			return formatCurrencyFn(cellValue);
		},
	},
	{
		cellKey: "notes",
		headerLabel: "備註",
		formatCell: cellValue => {
			return <MemoControllerBox data={cellValue} dialogTitle={"備註"} />;
		},
	},
	{
		cellKey: "more",
		headerLabel: "",
		width: 6.8,
		formatCell: (_, rowData, { refresh, dialogRef }) => {
			const menuData = buildOrderMenuData(rowData, { refresh, dialogRef });
			return <OverflowMenu menuData={menuData} />;
		},
	},
];
